import { Component, Fragment } from "react";
import Game from '../../Game/game';
import GameConfigurator from "../gameConfigurator";

class GameSingle extends Component {
	render() {
		return (
			<>
				<main className="game-area-background">
					<GameConfigurator />
				</main>
			</>
		)
	}
}

export default GameSingle